const NAME = 'confirmModal';

export const OPEN = `${NAME}/OPEN`;
export const CLOSE = `${NAME}/CLOSE`;
